module.exports = __webpack_public_path__ + "static/media/logo-cemig.4a9a29b0.png";